import { render, staticRenderFns } from "./CustomerPartCategories.vue?vue&type=template&id=59c3e912"
import script from "./CustomerPartCategories.vue?vue&type=script&lang=js"
export * from "./CustomerPartCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports